<template>
  <GModal class="modal--discard">
    <div slot="header">
      <h2 class="modal-heading">Discard Photo</h2>
    </div>

    <div slot="body">
      <p class="text">Anda yakin ingin menghapus photo ini?</p>
    </div>

    <div slot="footer">
      <div class="group-btn">
        <div class="col-btn">
          <a href="" class="btn btn-cancel btn-minimal" @click.prevent="close">Cancel</a>
        </div>
        <div class="col-btn s">
          <a href="" class="btn btn-publish" @click.prevent="discard">Discard</a>
        </div>
      </div>
    </div>
  </GModal>
</template>

<script>
export default {
  name: 'ModalDiscardConfirmationPhoto',
  computed: {
    productShotKey() {
      return this.$store.state.modal.confirmationPhoto.savedKeyRemovePhoto;
    },
  },
  methods: {
    close() {
      this.$store.commit('toggleModalGlobalState', { modalName: 'confirmationDiscardPhoto' });
      // this.$store.commit('setSavedKeyRemovePhoto', -1)
    },
    discard() {
      this.$store.dispatch('removeAllTemporaryProductShot');
      this.$store.commit('toggleModalGlobalState', { modalName: 'confirmationDiscardPhoto' });
      this.$store.dispatch('setModalUploadPhoto', false);
    },
  },
};
</script>
<style lang="scss" scoped>
@media (max-width: 740px) {
  ::v-deep .modal--discard {
    .modal-content {
      width: calc(100% - 50px);
    }
  }
}
</style>
